// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { useTranslation } from "react-i18next";
import { PRACTICE_GOAL } from "../../consts/practiceGoal";
import styles from "./practiceProgress.module.scss";

const PRACTICE_LEVELS = [
    { min: 100, i18nKey: "epic", className: "epic" },
    { min: 75, i18nKey: "advanced", className: "advanced" },
    { min: 25, i18nKey: "intermediate", className: "intermediate" },
    { min: 0, i18nKey: "beginner", className: "beginner" },
];

function PracticeProgress({ count, label, showLevel = false }) {
    const { t } = useTranslation("common");
    const completed = Math.min(count, PRACTICE_GOAL);
    const level = PRACTICE_LEVELS.find(({ min }) => count >= min) ?? PRACTICE_LEVELS[PRACTICE_LEVELS.length - 1];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.labelGroup}>
                    {label}
                    {showLevel && (
                        <span className={`${styles.level} ${styles[level.className]}`}>
                            {t(`practiceLevels.${level.i18nKey}`)}
                        </span>
                    )}
                </span>
                <span>{completed}/{PRACTICE_GOAL}</span>
            </div>
            <div
                className={styles.track}
                role="progressbar"
                aria-label={`${label} progress`}
                aria-valuemin="0"
                aria-valuemax={PRACTICE_GOAL}
                aria-valuenow={completed}
            >
                <div className={styles.fill} style={{ width: `${completed / PRACTICE_GOAL * 100}%` }} />
            </div>
        </div>
    );
}

export default PracticeProgress;
